const drivers = {
  table: {
    filters: {
      suppliers: 'Flotas',
    },
  },

  forms: {
    information: {
      supplier: {
        header: 'Flotas',
        fields: {
          suppliers: 'Flotas',
        },
      },
    },
  },
};

export default drivers;
